import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/** Case- and diacritic-insensitive substring match ("kosice" finds "Košice"). */
export function fuzzyIncludes(haystack: string, needle: string): boolean {
  const fold = (s: string) =>
    s
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
  return fold(haystack).includes(fold(needle))
}

export function formatPrice(price?: number | null, suffix = ''): string {
  if (!price || price <= 0) {
    return 'Cena neuvedená'
  }
  return `€${price.toLocaleString()}${suffix}`
}
